var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconListPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6713_75321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8574 12.4902L16.6146 10.3274L17.3141 11.0269C17.5338 11.2465 17.89 11.2465 18.1096 11.0269L18.9051 10.2314C19.1248 10.0117 19.1248 9.65556 18.9051 9.43588L14.3973 4.92808C14.1776 4.7084 13.8215 4.7084 13.6018 4.92808L12.8063 5.72357C12.5867 5.94325 12.5867 6.2994 12.8063 6.51907L13.5058 7.21856L11.343 8.97581C10.1654 8.54567 8.87424 8.595 8.03335 9.43588C7.81368 9.65556 7.81368 10.0117 8.03335 10.2314L10.2873 12.4853L8.56357 14.209C8.54299 14.2296 8.52747 14.2546 8.51828 14.2823L8.12053 15.4755C8.07179 15.6217 8.2112 15.7615 8.3577 15.7127L9.55094 15.3149C9.57856 15.3057 9.60366 15.2902 9.62425 15.2696L11.3479 13.546L13.6018 15.7999C13.8215 16.0195 14.1777 16.0195 14.3973 15.7999C15.2456 14.9516 15.2829 13.6553 14.8574 12.4902V12.4902Z",
    fill: "#00263E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6713_75321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    fill: "white",
    transform: "translate(13.4692 4) rotate(45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconListPin);
export default __webpack_public_path__ + "static/media/iconListPin.ca46c446a05d46f8ebf835945f0e16f7.svg";
export { ForwardRef as ReactComponent };